import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { selectCurrentDepartment } from "../departments/departmentsSlice";
import { SharedInterfaceVehicles } from "../../home/vehicles/sharedInterface";
import { useCallback, useEffect } from "react";
import {
  listVehiclesByDepartmentAsync,
  selectListAllVehiclesInDbStatus,
} from "../../home/vehicles/vehiclesSlice";
import { VehiclesListType } from "../../home/vehicles/vehiclesAPI";
import { useNavigate } from "react-router-dom";
import { VehicleSidePanel } from "../../home/vehicles/sidePanel/SidePanel";
import {
  driversHistoryByDepartmentAsync,
  selectDriversHistoryListStatus,
} from "../../home/fleet/fleetSlice";

export const DepartmentVehicles = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const department = useAppSelector(selectCurrentDepartment);
  const listAllVehiclesInDbStatus = useAppSelector(
    selectListAllVehiclesInDbStatus,
  );
  const driversHistoryListStatus = useAppSelector(
    selectDriversHistoryListStatus,
  );

  useEffect(() => {
    if (department && listAllVehiclesInDbStatus === "idle") {
      void dispatch(
        listVehiclesByDepartmentAsync({ departmentUuid: department.uuid }),
      );
    }
  }, [department, dispatch, listAllVehiclesInDbStatus]);

  useEffect(() => {
    if (department && driversHistoryListStatus === "idle") {
      void dispatch(driversHistoryByDepartmentAsync(department.uuid));
    }
  }, [department, dispatch, driversHistoryListStatus]);

  const sidePanelAction = useCallback(
    (props: Partial<VehiclesListType>) => {
      navigate(`/departments/vehicles/${props.uuid}`);
    },
    [navigate],
  );
  const reloadListWithDateFilters = useCallback(
    (dates: Date[]) => {
      if (!department) return;
      void dispatch(
        listVehiclesByDepartmentAsync({
          departmentUuid: department.uuid,
          from: dates[0].toISOString(),
          to: dates[1].toISOString(),
        }),
      );
    },
    [dispatch, department],
  );

  // const reloadListWithEndDatePeriod = useCallback(
  //   (date: Date) => {
  //     if (!department) return;
  //     void dispatch(
  //       listVehiclesByDepartmentAsync({
  //         departmentUuid: department.uuid,
  //         to: date.toISOString(),
  //       }),
  //     );
  //   },
  //   [dispatch, department],
  // );

  return (
    <SharedInterfaceVehicles
      hasAdvancedAnalytics={department?.hasAdvancedAnalytics}
      sidePanelAction={sidePanelAction}
      sidePanel={<VehicleSidePanel hasAdvancedAnalytics={department?.hasAdvancedAnalytics} />}
      //reloadListWithEndDatePeriod={reloadListWithEndDatePeriod}
      reloadListWithDateFilters={reloadListWithDateFilters}
    />
  );
};
